/**
 * Works with shared settings such as publishing and workflow statuses
 * @author Ryan Gladstone, Brendan Magee
 */

function schemaService(
  $http,
  $q,
  $log,
  $translate,
  distributorService,
  pitchStatusIndex,
  _
) {
  const service = {
    schemaState: {
      publish: [{
        id: 1,
        name: $translate.instant('NOT_LIVE'),
        icon: 'fa-pencil-square-o'
      },
      {
        id: 2,
        name: $translate.instant('SCHEDULED_F'),
        icon: 'fa-clock-o'
      },
      {
        id: 3,
        name: $translate.instant('LIVE'),
        icon: 'fa-check'
      }]
    },
    availableStatuses: []
  };

  service.getStatusString = (type, ids) => {
    const statusesState = service.schemaState[type];

    if (!statusesState || !ids) {
      return '';
    }

    return _.reduce([].concat(ids), (result, id) => {
      const status = service.schemaState[type]
        .find(stat => String(stat.id) === String(id));
      if (status) result.push(status.name);
      return result;
    }, []).join(', ');
  };

  service.getStatuses = (statusType) => {
    const deferred = $q.defer();

    if (service.schemaState[statusType]) {
      deferred.resolve(service.schemaState[statusType]);
    } else {
      $http.get(`api/statuses/${statusType}`, { cache: true })
        .success((data) => {
          service.schemaState[statusType] = data;
          deferred.resolve(data);
        })
        .error((data) => {
          deferred.reject(data);
        });
    }

    return deferred.promise;
  };

  service.getWorkflowStatus = (statusID) => {
    const deferred = $q.defer();

    service.getStatuses('workflow')
      .then((data) => {
        angular.forEach(data, (statusFromList) => {
          service.availableStatuses[statusFromList.id] = {
            name: statusFromList.name,
            color: statusFromList.color
          };
        });

        deferred.resolve(service.availableStatuses[statusID]);
      }, (response) => {
        // TODO: handle failure here
        $log.error('schemaService.getWorkflowStatus getStatuses error: ', response);
      });

    return deferred.promise;
  };

  service.getTaskInfo = (infoCategory) => {
    // types / statuses

    const deferred = $q.defer();

    $http.get(`api/tasks/${infoCategory}`, { cache: true })
      .success((data) => {
        if (infoCategory === 'statuses') {
          angular.forEach(data, (currentStatus) => {
            const status = currentStatus;
            switch (status.name) {
              case null || undefined:
                status.name = $translate.instant('UNKNOWN');
                break;
              case 'User Assigned':
                status.name = $translate.instant('TASK_META_USER_ASSIGNED');
                break;
              case 'Group Assigned':
                status.name = $translate.instant('TASK_META_GROUP_ASSIGNED');
                break;
              case 'Claimed':
                status.name = $translate.instant('TASK_META_CLAIMED');
                break;
              case 'Rejected':
                status.name = $translate.instant('TASK_META_REJECTED');
                break;
              case 'Completed':
                status.name = $translate.instant('TASK_META_COMPLETED');
                break;
              default:
                status.name = status.name;
            }
          });
        }

        deferred.resolve(data);
      })
      .error((data) => {
        deferred.reject(data);
      });

    return deferred.promise;
  };

  service.getContentTypes = () => {
    const types = [
      {
        id: 'article',
        name: $translate.instant('ARTICLE')
      },
      {
        id: 'video',
        name: $translate.instant('VIDEO')
      },
      {
        id: 'gallery',
        name: $translate.instant('GALLERY')
      },
      {
        id: 'graphic',
        name: $translate.instant('GRAPHIC')
      }
    ];

    return $q.when(types);
  };

  service.getTaskPriorities = () => {
    const priorities = [
      {
        id: 1,
        name: $translate.instant('PRIORITY_LOW')
      },
      {
        id: 2,
        name: $translate.instant('PRIORITY_MEDIUM')
      },
      {
        id: 3,
        name: $translate.instant('PRIORITY_HIGH')
      }
    ];

    return $q.when(priorities);
  };

  service.getPitchStatuses = (type) => {
    let statuses = null;

    if (type === 'platform') {
      statuses = pitchStatusIndex.getListCopy('platformStatuses');
    } else if (type === 'publication') {
      statuses = pitchStatusIndex.getListCopy('publicationStatuses');
    }

    return $q.when(statuses);
  };

  service.getSourceTypes = async () => {
    const categories = await distributorService.getByType('categories');

    // TODO: Remove fallback when Settings API available in all environments
    return categories.list
      || [
        {
          id: 'staff',
          name: $translate.instant('DISTRIBUTOR.CATEGORY.STAFF')
        },
        {
          id: 'wires',
          name: $translate.instant('DISTRIBUTOR.CATEGORY.WIRES')
        },
        {
          id: 'freelance',
          name: $translate.instant('DISTRIBUTOR.CATEGORY.FREELANCE')
        },
        {
          id: 'stock',
          name: $translate.instant('DISTRIBUTOR.CATEGORY.STOCK')
        },
        {
          id: 'handout',
          name: $translate.instant('DISTRIBUTOR.CATEGORY.HANDOUT')
        },
        {
          id: 'other',
          name: $translate.instant('DISTRIBUTOR.CATEGORY.OTHER')
        }
      ];
  };

  service.getSponsoredSchema = () => {
    const types = [
      {
        id: 'editorial',
        name: $translate.instant('EDITORIAL')
      },
      {
        id: 'sponsored',
        name: $translate.instant('SPONSORED')
      }
    ];

    return $q.when(types);
  };

  service.getStatuses('workflow');

  return service;
}

const arr = [
  '$http',
  '$q',
  '$log',
  '$translate',
  'distributorService',
  'pitchStatusIndex',
  '_',
  schemaService
];

module.exports = (ngModule) => {
  ngModule.service('schemaService', arr);
};
